
import rzIconWarningTriangle from '../../icons/icon-warning-triangle/index.vue';
import rzModalWindowMobile from '../modal-window-mobile/index.vue';
import rzButton from '../button/index.js';

export default {
  name: 'rzOfflineModal',
  components: {
    rzModalWindowMobile, 
    rzIconWarningTriangle,
    rzButton,
  },
  props: {
    title: {
      type: String,
      default: 'Соединение с интернетом временно недоступно',
    },
    buttonTitle: {
      type: String,
      default: 'Перезагрузить страницу',
    },
  },
  methods: {
    reload() {
      window.location.reload();
    }
  },
};
